export default function InputHider() {
	const hiders = document.querySelectorAll('[data-js-input-hider]');

	hiders.forEach(hider => {
		const collapseSibling = document.getElementById(hider.dataset.bsTarget.replace('.', ''));

		hider.addEventListener('change', e => {
			e.target.value = '';
		});

		hider.addEventListener('click', e => {
			if (collapseSibling) {
				const ckEditor = collapseSibling.querySelector('form .ck-content');
				const targetTextArea = ckEditor ? ckEditor : collapseSibling.querySelector('form input:not([type="hidden"]), form textarea, form .ck-content');

				if (targetTextArea) {
					setTimeout(() => {
						targetTextArea.focus();
					}, 500);
				}
			}
		});
	});
}
